(function () {
    const timers = document.querySelectorAll('.countdown-timer');

    function getEndOfDayEastern() {
      // Get the current time in ET using Intl
      const now = new Date();
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });

      const [{ value: month }, , { value: day }, , { value: year }] = formatter.formatToParts(now);

      // Construct 23:59:59 ET as ISO string
      const endOfDayETString = `${year}-${month}-${day}T23:59:59-05:00`; // Offset will be corrected for DST

      return new Date(endOfDayETString);
    }

    function startCountdown(targetDate) {
      const target = new Date(targetDate).getTime();

      const timer = setInterval(function () {
        const now = new Date().getTime();
        const distance = target - now;

        if (distance < 0) {
          clearInterval(timer);
          timers.forEach((t) => (t.innerHTML = 'Expired'));
          return;
        }

        const totalSeconds = Math.floor(distance / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        timers.forEach((t) => {
          t.querySelector('.cd-hours').innerText = hours.toString().padStart(2, '0');
          t.querySelector('.cd-minutes').innerText = minutes.toString().padStart(2, '0');
          t.querySelector('.cd-seconds').innerText = seconds.toString().padStart(2, '0');
        });
      }, 1000);
    }

    const endOfDayET = getEndOfDayEastern();
    startCountdown(endOfDayET);
  })();